import { Image, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import Layout from 'Components/Layout';
import LogoTalentaInsight from 'Components/Logo';
import PanicContent from 'Containers/PanicContent';
import Menu from 'Components/Menu';
import Footer from 'Components/Footer';
import { appRoutes } from 'Config/route';
import Navbar from 'Components/Navbar';

function PageNotFound() {
  return (
    <Layout>
      <div className='header-section'>
        <div className='header-logo-container'>
          <div className='header-logo'>
            <LogoTalentaInsight />
          </div>
        </div>
        <div className='header-menu-container' span={18} style={{ background: 'white' }}>
          <div className='header-menu'>
            <Menu />
          </div>
        </div>
        <div className='header-download-container' style={{ background: 'white' }}>
          <Tooltip title='Export History' placement='left' className='nav-menu'>
            <Link to={appRoutes.EXPORT_HISTORY}>
              <Image src='Download.png' preview={false} />
            </Link>
          </Tooltip>
        </div>
        <div className='header-navbar-container'>
          <div className='header-navbar'>
            <Navbar />
          </div>
        </div>
      </div>
      <PanicContent type="404" />
      <Footer />
    </Layout>
  );
}

export default PageNotFound;
